export const adaptCPResumen = (data) => {
    const { cuidadosPaliativosRI } = data;

    return {
        ...cuidadosPaliativosRI,
        directivasAdjunto: !!data?.directivasAdjunto?.contentType ? {
            contentType: data?.directivasAdjunto?.contentType,
            titulo: data?.directivasAdjunto?.titulo,
            archivo: data?.directivasAdjunto?.archivo,
            extension: data?.directivasAdjunto?.extension
        } : null,
        videodeglucionAdjuntoCP: !!data?.videodeglucionAdjunto?.contentType ? {
            contentType: data?.videodeglucionAdjunto?.contentType,
            archivo: data?.videodeglucionAdjunto?.archivo,
            extension: data?.videodeglucionAdjunto?.extension,
            titulo: data?.videodeglucionAdjunto?.titulo,
        } : null,
        estudioAdjunto: data?.estudioAdjunto.map((estudio) => {
            return {
                contentType: estudio?.contentType,
                titulo: estudio?.titulo,
                archivo: estudio?.archivo,
                extension: estudio?.extension
            }
        }),
        comboRIValorECOG: cuidadosPaliativosRI?.idComboRIValorECOGNavigation?.valor,
        comboRIValorTabaquismo: cuidadosPaliativosRI?.idComboRIValorTabaquismoNavigation?.valor,
        sondaVesicalCP: cuidadosPaliativosRI?.sondaVesical,
        sondaNasogastricaCP: cuidadosPaliativosRI?.sondaNasogastrica,
        cateterCP: cuidadosPaliativosRI?.cateter,
        videodeglucionCP: cuidadosPaliativosRI?.videodeglucion,
        soporteNutricionalCP: cuidadosPaliativosRI?.soporteNutricional,
        idComboRIValorPedLANSKYCP: cuidadosPaliativosRI?.idComboRIValorPedLANSKYNavigation?.valor,
        idComboRIValorPedEscalaDolorCP: cuidadosPaliativosRI?.idComboRIValorPedEscalaDolorNavigation?.valor,
        comboRIValorPoseeInfDiagnosticaCP: cuidadosPaliativosRI?.idComboRIValorPoseeInfDiagnosticaNavigation?.valor,
        comboRIValorPoseeInfPronosticoCP: cuidadosPaliativosRI?.idComboRIValorPoseeInfPronosticoNavigation?.valor,
        comboRIValorPoseeInfEnfermedadCP: cuidadosPaliativosRI?.idComboRIValorPoseeInfEnfermedadNavigation?.valor,
        comboRIValorNombraPalabraCancerCP: cuidadosPaliativosRI?.idComboRIValorNombraPalabraCancerNavigation?.valor,
        comboRIValorCercoDeSilencioCP: cuidadosPaliativosRI?.idComboRIValorCercoDeSilencioNavigation?.valor,
        comboRIValorTrastornoAdaptacionCP: cuidadosPaliativosRI?.idComboRIValorTrastornoAdaptacionNavigation?.valor,
        cPMedicacionDosificacionRI: cuidadosPaliativosRI?.cPMedicacionDosificacionRI.map((cpMed) => ({descripcion:cpMed.descripcion})),
        otrasIndicacionesCP: cuidadosPaliativosRI?.otrasIndicaciones,
        resultadoAduESASResumido: data?.resultadoAduESASResumido
    }
}